const HOUSE_RULE_TRACKING_NAMES = {
  TAXESINCLUDED: 'tax',
  TAXESNOTINCLUDED: 'tax',
  AGERESTRICTION: 'age',
  HOUSERULESAGELIMITALLOWED: 'age',
  CHILDFRIENDLY: 'children',
  HOUSERULESCHILDRENALLOWED: 'children',
  HOUSERULESCHILDRENNOTALLOWED: 'children',
  CREDITCARDSACCEPTED: 'credit_cards',
  CREDITCARDSNOTACCEPTED: 'credit_cards',
  CURFEW: 'curfew',
  HOUSERULESCURFEWALLOWED: 'curfew',
  HOUSERULESCURFEWNOTALLOWED: 'curfew',
  NONSMOKING: 'smoking',
  HOUSERULESNOSMOKING: 'smoking',
  HOUSERULESSMOKING: 'smoking',
  PETFRIENDLY: 'pets',
  HOUSERULESPETSALLOWED: 'pets',
  HOUSERULESPETSNOTALLOWED: 'pets',
};

export function getHouseRulesTracking(policies) {
  if (!policies || typeof policies !== 'object') {
    return {
      house_rules_displayed: '',
      new_house_rules_service_flag: false,
    };
  }

  const displayedRules = Array.isArray(policies.rules) ? policies.rules : policies.additional || [];
  const houseRulesDisplayed = displayedRules
    .map((rule) => HOUSE_RULE_TRACKING_NAMES[typeof rule === 'string' ? rule : rule?.title])
    .filter((rule, index, rules) => rule && rules.indexOf(rule) === index)
    .join('|');
  const hasNewHouseRules = [
    policies.ageLimit?.ageRestriction,
    policies.children?.allowChildren,
    policies.curfew?.enabled,
    policies.smoking,
    policies.pets?.allowed,
  ].some((value) => value !== null && value !== undefined);

  return {
    house_rules_displayed: houseRulesDisplayed,
    new_house_rules_service_flag: hasNewHouseRules,
  };
}
